import { useEffect, useMemo, useState } from 'react'
import { ApplicationStatusEnum, PolymerStatusEnum } from '../models/enum/application-status.enum'
import { useAppSelector } from '../redux/hook';
import { useGetStageD1ObjQuery } from '../redux/services/getStageD';

function useGetIpaLetter(application_status?: ApplicationStatusEnum, polymer_status?: PolymerStatusEnum) {
  
  
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);

  // const queryParameters = new URLSearchParams(window.location.search)
  const application_uuid = useAppSelector(state => state.app.ApplicationIdSlice.applicationId);
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  
  const isActivated = useMemo(()=>{
    const accepted_application_status_value:ApplicationStatusEnum[] = ["APPROVE", "REVIEW_FINANCIAL_PLAN","PREPARE_FOR_COMPLETION"];
    const accepted_polymer_status_value:PolymerStatusEnum = "E";
    
    if((application_status && accepted_application_status_value.includes(application_status)) && accepted_polymer_status_value === polymer_status) {
      return true;
    }
    else{
      return false;
    }
  },[application_status, polymer_status])


  const { data, isLoading } = useGetStageD1ObjQuery({ application_uuid: application_uuid!, uinfin: loginUser?.uinfin ?? "", stage: "D2", singpass_token: singpassToken ?? "" }, { skip: !application_uuid && !isActivated  } );
  const [ ipa_key, setKey] = useState<string | undefined>( undefined );

  useEffect(()=>{
    if(!isLoading && data){
      try{
        setKey(data?.folders[0].comments[0].documents[0].key);
      }catch(e){
        console.log("useGetIpaLetter -- catch");
      }
    }
  },[data, isLoading])

  return { ipa_key };
}

export default useGetIpaLetter